import { action, computed, observable, toJS, IObservableValue } from 'mobx';

export default class AuthService {

  private static _instance: AuthService;

  @observable
  private _user: GQL.IUser | null = null;

  public static GetInstance() {
    if (this._instance == undefined) {
      this._instance = new AuthService();
    }

    this._instance.initialize();
    
    return this._instance;
  }

  @computed
  public get loggedIn() {
    return (this._user !== undefined && this._user !== null);
  }

  @computed
  public get loggedUser() {
    return this._user;
  }

  @action
  public setLoggedUser(user: GQL.IUser | null) {
    if (user) {
      this._user = {...user};
      localStorage.setItem('user', JSON.stringify(user));
    }
  }

  @computed
  public get privileges() {
    if (this._user && this._user.privileges) {
      return [...this._user.privileges];
    }

    return [];
  }

  private initialize() {
    const tempUser = localStorage.getItem('user');
    if (tempUser) {
      this._user = JSON.parse(tempUser);
    } else {
      this._user = null;
    }
  }

  private constructor() {
    this.initialize();
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.ts